import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Check } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-black relative overflow-hidden" data-id="element-91">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-gold-dark/10 via-black to-black pointer-events-none" data-id="element-92"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-93">
        <div className="text-center mb-16" data-id="element-94">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight" data-id="element-95">
            Next Monday you can keep improvising...
            <br data-id="element-96" />
            <span className="text-gold-gradient" data-id="element-97">
              Or you can walk into class with everything ready from today.
            </span>
          </h2>

          <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-dark-card p-8 rounded-2xl border border-dark-border" data-id="element-98">
            {['No more nights searching for how to explain complex methodological concepts', 'No more lessons built in a rush with material that does not work', 'No more disconnected students who do not understand why research methodology matters', 'No more weekends lost building material from scratch', 'No more uncomfortable silences in front of questions that put you on the spot'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-99">
                <span className="text-gold mt-1" data-id="element-100">▸</span>
                <span className="text-gray-300" data-id="element-101">{item}</span>
              </div>)}
          </div>

          <p className="text-xl text-white mb-2" data-id="element-102">
            Research Methods Ready™ does not make you a better teacher.
          </p>
          <p className="text-2xl font-bold text-gold mb-6" data-id="element-103">
            You are already a great teacher.
          </p>
          <p className="text-xl text-gray-300 mb-16" data-id="element-104">
            What Research Methods Ready™ does is give you the time and the
            tools to make that visible in every single class.
          </p>
        </div>

        <div className="bg-black border-2 border-gold/30 rounded-3xl p-8 md:p-12 shadow-[0_0_40px_rgba(212,175,55,0.1)]" data-id="element-105">
          <h3 className="text-2xl font-bold text-white mb-6 text-center border-b border-dark-border pb-6" data-id="element-106">
            Everything that is included:
          </h3>

          <div className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-107">
            {['Component 1 — Research Foundations', 'Component 2 — Research Questions & Objectives', 'Component 3 — Literature Review & Framework', 'Component 4 — Research Design & Approaches', 'Component 5 — Population, Sampling & Instruments', 'Component 6 — Data Analysis & Results', 'Bonus 1 — Master Activity Pack', 'Bonus 2 — Advanced Assessment Pack', 'Bonus 3 — Premium Glossary', 'Bonus 4 — Annual Project Templates', 'Bonus 5 — Cheat-Proof Rubric Library', '7-day money back guarantee', 'Immediate access', 'Pay in your local currency', 'PDF format ready to use'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-108">
                <Check size={18} className="text-gold shrink-0" data-id="element-109" />
                <span className="text-sm text-gray-200" data-id="element-110">{item}</span>
              </div>)}
          </div>

          <div className="text-center" data-id="element-111">
            <div className="mb-8 p-6 bg-gold/5 rounded-xl border border-gold/20 italic text-gray-300 text-lg" data-id="element-112">
              "The best moment to have this material was at the start of the
              school year.
              <br data-id="element-113" />
              <span className="text-gold font-bold not-italic" data-id="element-114">
                The second best moment is today.
              </span>
              "
            </div>

            <p className="text-xl font-serif font-bold text-white mb-2" data-id="element-115">
              📚 Research Methods Ready™
            </p>
            <p className="text-sm text-gray-400 mb-8" data-id="element-116">
              Built by specialists, for Research Methods educators worldwide.
            </p>

            <Button href="https://research-methods-ready.impultienda.ar/checkout" target="_blank" onLinkClick={() => {
            if (typeof window !== 'undefined' && (window as any).fbq) {
              ;
              (window as any).fbq('track', 'InitiateCheckout', {
                content_name: 'Research Methods Ready Complete Pack',
                value: 27.0,
                currency: 'USD'
              });
            }
          }} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-117">
              🟡 I WANT MY COMPLETE PACK NOW
            </Button>

            <div className="flex flex-wrap justify-center gap-4 text-xs text-gray-500" data-id="element-118">
              <span data-id="element-119">✅ 7-day guarantee</span>
              <span data-id="element-120">✅ Secure payment</span>
              <span data-id="element-121">✅ Immediate access</span>
              <span data-id="element-122">✅ Pay in your local currency</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}